import { render } from "./Hotspot15.vue?vue&type=template&id=a4655f6c&scoped=true&ts=true"
import script from "./Hotspot15.vue?vue&type=script&lang=ts"
export * from "./Hotspot15.vue?vue&type=script&lang=ts"

import "./Hotspot15.vue?vue&type=style&index=0&id=a4655f6c&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4655f6c"]])

export default __exports__